'use client'
import {usePathname} from 'next/navigation'
import Link from 'next/link'

import Icon from '@/components/UI/Icon/Icon'
import Body5 from '@/components/UI/Typography/body5'
import {Body7} from '@/components/UI/Typography'

import {SideMenuLinkProps} from './types'
import Box from '../../UI/Box/Box'

const SideMenuLink = ({text, href, iconName, IsNew}: SideMenuLinkProps) => {
  const pathname = usePathname()

  return (
    <Box
      className={`cursor-pointer hover:opacity-100 ${href === pathname ? 'opacity-100' : 'opacity-60'}`}>
      <Link className="w-full h-full p-2" href={href}>
        <Box className="items-center gap-2">
          <Icon name={iconName} size={20} className="fill-primary" />
          <Body5>{text}</Body5>
          {IsNew && (
            <Body7 className="text-primary bg-white border-1 border-solid border-primary rounded-xl px-2 py-[2px]">
              Yeni
            </Body7>
          )}
        </Box>
      </Link>
    </Box>
  )
}

export default SideMenuLink
